import {useEffect,useLayoutEffect} from 'react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {loadHtmlIntoEditor,buildOutput} from '../utils/htmlIO';
import {$ensureStructure} from '../utils/structure';
export default function StructurePlugin({initialHtml,baselineRef,onDirtyChange}) {
 const [editor]=useLexicalComposerContext();
 useLayoutEffect(()=>{loadHtmlIntoEditor(editor,initialHtml);baselineRef.current=buildOutput(editor);onDirtyChange(false);},[editor,initialHtml,baselineRef,onDirtyChange]);
 useEffect(()=>{
   let timer;
   const off=editor.registerUpdateListener(({dirtyElements,dirtyLeaves,tags})=>{
     if(!dirtyElements.size&&!dirtyLeaves.size)return;
     if(!tags.has('doc-structure'))editor.update(()=>{$ensureStructure();},{tag:['history-merge','doc-structure']});
     clearTimeout(timer);timer=setTimeout(()=>onDirtyChange(buildOutput(editor)!==baselineRef.current),150);
   });
   return()=>{off();clearTimeout(timer);};
 },[editor,baselineRef,onDirtyChange]);
 return null;
}
